import { announcementFetchRoutine } from 'actions/routines/announcements';
import { createAllIdsReducer } from 'store/redux';
export default createAllIdsReducer({
    key: 'userFeatureAnnouncement',
    types: [announcementFetchRoutine.SUCCESS],
});
